import { ProcessoCadastro } from "./processo-cadastro";

export interface ProcessoPreCadastroFornecedor {
  NCODIGO: number;
  NCODIGOPROCESSOCADASTRO: number;
  CA2COD: string;
  CA2LOJA: string;
  CA2NOME: string;
  CA2NREDUZ: string;
  CA2CONTATO: string;
  CA2TIPO: string;
  CA2CEP: string;
  CA2END: string;
  CA2COMPLEM: string;
  CA2BAIRRO: string;
  CA2EST: string;
  CA2COD_MUN: string;
  CA2MUN: string;
  CA2CGC: string;
  CA2INSCR: string;
  CA2INSCRM: string;
  CA2DDD: string;
  CA2TEL: string;
  CA2NATUREZ: string;
  CA2CONTA: string;
  CA2EMAIL: string;
  CA2CODPAIS: string;
  CA2PAIS: string;
  CA2FAX: string;
  CA2HPAGE: string;
  CA2PFISICA: string;
  CA2GRPTRIB: string;
  CA2COND: string;
  CA2BANCO: string;
  CA2AGENCIA: string;
  CA2NUMCON: string;
  CA2CX_POST: string;
}

export const defaultProcessoPreCadastroFornecedor = (): ProcessoPreCadastroFornecedor => {
  return {
    NCODIGO: 0,
    NCODIGOPROCESSOCADASTRO: 0,
    CA2COD: '',
    CA2LOJA: '',
    CA2NOME: '',
    CA2NREDUZ: '',
    CA2CONTATO: '',
    CA2TIPO: '',
    CA2CEP: '',
    CA2END: '',
    CA2COMPLEM: '',
    CA2BAIRRO: '',
    CA2EST: '',
    CA2COD_MUN: '',
    CA2MUN: '',
    CA2CGC: '',
    CA2INSCR: '',
    CA2INSCRM: '',
    CA2DDD: '',
    CA2TEL: '',
    CA2NATUREZ: '',
    CA2CONTA: '',
    CA2EMAIL: '',
    CA2CODPAIS: '',
    CA2PAIS: '',
    CA2FAX: '',
    CA2HPAGE: '',
    CA2PFISICA: '',
    CA2GRPTRIB: '',
    CA2COND: '',
    CA2BANCO: '',
    CA2AGENCIA: '',
    CA2NUMCON: '',
    CA2CX_POST: '',
  };
};

export interface ProcessoPreCadastroFornecedorListaItem {
  NPROCESSOCODIGO: number;
  NCODIGO: number;
  CSTATUS: string;
  CCHAVE: string;
  CURGENTE: string;
  CA2COD: string;
  CA2LOJA: string;
  CA2NOME: string;
  CUSRID: string;
  CUSRNOME: string;
  DINCLUSAO: Date | undefined;
  DFINALIZACAO: Date | undefined;
}

export const defaultProcessoPreCadastroFornecedorListaItem = (): ProcessoPreCadastroFornecedorListaItem => {
  return {
    NPROCESSOCODIGO: 0,
    NCODIGO: 0,
    CSTATUS: '',
    CCHAVE: '',
    CURGENTE: '',
    CA2COD: '',
    CA2LOJA: '',
    CA2NOME: '',
    CUSRID: '',
    CUSRNOME: '',
    DINCLUSAO: undefined,
    DFINALIZACAO: undefined,
  };
};

export interface ProcessoPreCadastroFornecedorLista {
  items: Array<ProcessoPreCadastroFornecedorListaItem>;
  hasNext: boolean;
}

export const defaultProcessoCadastroDtoList = (): ProcessoPreCadastroFornecedorLista => {
  return {
    items: [],
    hasNext: false,
  };
};

export interface ProcessoPreCadastroFornecedorDto {
  FORNECEDOR: ProcessoPreCadastroFornecedor;
  CHISTORICO: string;
  CDECISAO: string;
  CURGENTE: string;
}
